import { QueryString } from 'common/interfaces/common';

export const convertObjectToQueryString = (query: QueryString): string => {
  return Object.entries(query)
    .map(([key, val]) => `${key}:${val}`)
    .join(',');
};
